import {
  BehaviorSubject,
  catchError,
  delay,
  filter,
  from,
  mergeMap,
  Observable,
  of,
} from 'rxjs';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import { signOut } from '../../../state/authentication/authentication.action';
import {
  retrieveTournamentsByUser,
  retrieveTournamentsByUserFailure,
  retrieveTournamentsByUserSuccess,
} from '../../../state/tournament/tournament.action';
import {
  RetrieveTournamentsByUser,
  RETRIEVE_TOURNAMENTS_BY_USER,
} from '../../../state/tournament/tournament.action.type';
import { DEFAULT_RETRY_DELAY } from '../../constants/retry.constant';
import {
  TokenExpiredError,
  TokenInvalidError,
} from '../../errors/authentication.error';
import { AUTH_API_ERROR_MESSAGES } from '../../errors/gateway.errorMessages/authentication.error.messages';
import { CleanTournament } from '../../models/tournament.model';

export const retrieveTournamentsByUserUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: AnyAction): action is RetrieveTournamentsByUser =>
        action.type === RETRIEVE_TOURNAMENTS_BY_USER,
    ),
    mergeMap((action: RetrieveTournamentsByUser) =>
      from(
        dependencies.tournamentsGateway.retrieveTournamentsByUser(
          action.payload.token,
        ),
      ).pipe(
        mergeMap((userTournaments: CleanTournament[]) => {
          return [retrieveTournamentsByUserSuccess({ userTournaments })];
        }),
        catchError((error: Error) => {
          console.warn(
            'retrieveTournamentsByUserUsecase failed:',
            error.message,
          );

          const remainingRetries = action.payload.retry
            ? action.payload.retry - 1
            : 0;
          if (remainingRetries) {
            return of(
              retrieveTournamentsByUser({
                token: action.payload.token,
                retry: remainingRetries,
              }),
            ).pipe(delay(DEFAULT_RETRY_DELAY));
          }

          if (
            error instanceof TokenExpiredError ||
            error instanceof TokenInvalidError
          ) {
            return of(
              retrieveTournamentsByUserFailure(
                AUTH_API_ERROR_MESSAGES.TOKEN_EXPIRED,
              ),
              signOut(),
            );
          }

          return of(retrieveTournamentsByUserFailure(error.message));
        }),
      ),
    ),
  );
